import React from 'react'
import { ListPlus } from 'lucide-react'

const PlaylistEmptyView = (props) => {
    return (
        <div style={{
            display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
            padding: '48px 24px', textAlign: 'center',
        }}>
            <div style={{
                width: 64, height: 64, borderRadius: 20,
                background: 'linear-gradient(135deg, #eef2ff, #e0e7ff)',
                display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 16,
            }}>
                <ListPlus size={28} color="#6366f1" />
            </div>
            <div style={{ fontWeight: 600, fontSize: 16, color: '#1e293b', marginBottom: 8 }}>
                Playlist is Empty
            </div>
            <div style={{ fontSize: 14, color: '#94a3b8', maxWidth: 300, lineHeight: 1.6 }}>
                Drag content from the right panel or use the add button to get started.
            </div>
        </div>
    )
}

export default PlaylistEmptyView
